/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbTypeCoursGridDto } from './FcbTypeCoursGridDto';
import {
    FcbTypeCoursGridDtoFromJSON,
    FcbTypeCoursGridDtoFromJSONTyped,
    FcbTypeCoursGridDtoToJSON,
} from './FcbTypeCoursGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbTypeCoursGridDtoPaginatedResults
 */
export interface FcbTypeCoursGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbTypeCoursGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbTypeCoursGridDto>}
     * @memberof FcbTypeCoursGridDtoPaginatedResults
     */
    results?: Array<FcbTypeCoursGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbTypeCoursGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbTypeCoursGridDtoPaginatedResults interface.
 */
export function instanceOfFcbTypeCoursGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeCoursGridDtoPaginatedResultsFromJSON(json: any): FcbTypeCoursGridDtoPaginatedResults {
    return FcbTypeCoursGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbTypeCoursGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeCoursGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbTypeCoursGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbTypeCoursGridDtoPaginatedResultsToJSON(value?: FcbTypeCoursGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbTypeCoursGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

